import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { StringParam, withDefault, useQueryParams } from 'use-query-params';
import withQueryParamsProvider from '../../../../../shared/components/withQueryParamsProvider';
import AffiliateLogList from '../AffiliateLogList';

const LogTab = props => {
  const [query, setQuery] = useQueryParams({
    tab: withDefault(StringParam, ''),
  });

  const { tab } = query;

  useEffect(() => {
    setQuery({ tab: 'logs' }, 'replaceIn');
  }, [tab]);

  return <AffiliateLogList affiliateId={props.id} />;
};

LogTab.propTypes = {
  id: PropTypes.number.isRequired,
};

LogTab.propTypes = {
  id: PropTypes.number.isRequired,
};

export default withQueryParamsProvider(LogTab);
